import { render } from "./SpecimenMeasure.vue?vue&type=template&id=399f8cba&scoped=true"
import script from "./SpecimenMeasure.vue?vue&type=script&lang=js"
export * from "./SpecimenMeasure.vue?vue&type=script&lang=js"

import "./SpecimenMeasure.vue?vue&type=style&index=0&id=399f8cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399f8cba"]])

export default __exports__